import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex);

import PollStore from './PollStore';
import QuestionStore from './QuestionStore';
import StatsStore from './StatsStore';
import UserStore from './UserStore';

export const defaultErrorHandler = () => {
  // we do nothing by default since the error was catched and a notification
  // was displayed by the HttpService.onError(),
  // we still need to catch the promise though, because otherwise it'd result
  // in an unhandled promise rejection error
};

export default new Vuex.Store({
  plugins: process.env.NODE_ENV === 'production' ? [] : [createLogger()],
  modules: {
    poll: PollStore,
    question: QuestionStore,
    stats: StatsStore,
    user: UserStore
  },
  strict: true
});
